var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$debug && !_vm.forceHide)?_c('div',[_c('div',{staticClass:"container mt-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('i',[_vm._v("## Debug ##")]),_c('br'),_vm._t("default")],2)])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }